<template>
  <div class="shareAndEarn" v-if="details.groupSize > 0">
    <div
      class="share"      
    >
      <div class="share_link">
        <h3 class="share_hdng">{{$t('shareAndGetChashBack')}}</h3>
        <p class="cashback_txt">{{$t('shareWithFrndsAndGetCashback',{cashbackAmount:parseFloat(details.cashBackPer), orderCount:Math.round(parseFloat(details.groupSize)-1)})}}</p>
        <div class="customButtom flx">
          <button type="button" class="share_btn" @click="shareFunc(details.shareMessageUrl,details.itemMediaDTOList[0].original, details.sellerItemRelationshipId)">{{$t('shareAndEarn')}}</button>
          <!-- <span class="video_btn flx" @click="openVideo()"><span class="material-icons">play_arrow</span><span>वीडियो से समझें</span></span> -->
        </div>
      </div>
    </div>
    <div class="youtube-video" v-if="isYtVideo">
      <div class="container">
        <i class="material-icons" @click="isYtVideo = !isYtVideo">close</i>
        <iframe src="https://www.youtube.com/embed/rt26MNPm9ko?autoplay=1" height="200" width="300" title="Iframe Example"></iframe>
      </div>
    </div>
  </div>
</template>

<script>
import ApiCaller from "../../../utils/apicaller";
import constant from "../../../utils/constant";
export default {
  name: "ShareAndEarn",
  props: {
    dataShareAndEarn: {
      required: true,
      type: Object
    }
  },
  data() {
    return {
      shareLinkData: {},
      details: {},
      loading: false,
      isYtVideo: false
    };
  },
  watch: {
    dataShareAndEarn() {
      this.details = this.dataShareAndEarn;
    }
  },
  methods: {
    openVideo(){
      this.isYtVideo = !this.isYtVideo
    },
    shareFunc(shareMessage, shareImage, saleReferenceID) {
      if (this.$cookie.get("X-Auth-Id") != null) {
         try {
          JSBridgePlugin.fireEvents("Detail_Page_Product_Shared");
        } catch (err) {
          console.log(err);
        }
        this.loading = true;
        ApiCaller(
          constant.LOCAL_SHOP_URL,
          `get-share-details/${saleReferenceID}?type=ITEM`,
          "get"
        )
          .then(data => {
            this.shareLinkData = data.data;
            this.loading = false;
            shareMessage = data.data.shareMessage;
            const obj = {
              message: shareMessage,
              imageUrl: shareImage
            };
            try {
              JSBridgePlugin.share(JSON.stringify(obj));
            } catch (err) {
              console.log(err);
              window.open("whatsapp://send?text=" + shareMessage);
            }
          })
          .catch(err => {
            this.loading = false;
            console.log(err);
          });
      } else {
        try {
          _prompt_login.promptLogin = res => {
            if (res == "success") {
              console.log(res);
            } else {
              this.loading = false;
            }
          };
          JSBridgePlugin.promptLogin("_prompt_login.promptLogin");
        } catch (err) {
          this.loading = false;
          console.log(err);
        }
      }
    }
  },
  mounted() {
    this.details = this.dataShareAndEarn;
  }
};
</script>
    